"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var genIcon_1 = __importDefault(require("../../utils/genIcon"));
/**
 * The KPIStatistic is used to easily display Key Performance Indicators (KPI's), helping compare values of an attribute and act as a performance measurement.
 */
var KPIStatistic = /** @class */ (function (_super) {
    __extends(KPIStatistic, _super);
    function KPIStatistic() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.genClasses = function () {
            var className = _this.props.className;
            var classes = "ui kpi-statistic";
            if (className) {
                classes += ' ' + className;
            }
            return classes;
        };
        return _this;
    }
    KPIStatistic.prototype.render = function () {
        var _a = this.props, icon = _a.icon, iconRoot = _a.iconRoot, title = _a.title, value = _a.value, targetValue = _a.targetValue, valueColor = _a.valueColor, imageUrl = _a.imageUrl, indicator = _a.indicator;
        return (React.createElement("div", { className: this.genClasses() },
            imageUrl && React.createElement("div", { className: "item-image", style: { 'backgroundImage': "url(" + imageUrl + ")" } }),
            icon && !imageUrl && genIcon_1.default(icon, { root: iconRoot }),
            React.createElement("div", { className: "statistic-details" },
                React.createElement("h1", { className: valueColor + " " }, value),
                React.createElement("h5", null, title),
                !indicator && React.createElement("h3", null, targetValue),
                indicator &&
                    React.createElement("div", { className: "indicator-target-panel" },
                        React.createElement("span", { className: "dot " + indicator }),
                        React.createElement("h3", null, targetValue)))));
    };
    return KPIStatistic;
}(React.Component));
exports.default = KPIStatistic;
